import axios from "axios";
import {
  Button,
  IconButton,
} from "@mui/material";
import styles from "./style.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import {
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import ReportsTable from '../../custom/reportsTable';
import {
  CalendarIcon,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { MomentInput } from "moment";
import { salesReportHeader } from "../../../utils/constant";
import Title from "../../custom/Title";
import useService from "../../../hooks/useService";
import { AuthContext } from "../../../contexts/AuthContext";
import { getSalesReport } from "../../../services/Reports";

const DataGridContainer = styled.div`
  height: calc(100%);
  overflow-x: auto;
`;
export const SalesReport = () => {
  let sessionId: any = localStorage.getItem("sessionId");
  const [loading, setLoading] = useState(false);
  const [salesReportData, setSalesReportData] = useState<any>([]);
  const [fromDate, setFromDate] = useState<any>(new Date().toString());
  const [toDate, setToDate] = useState<any>(new Date().toString());
  const [destinationOptions, setDestinationOptions] = useState<any>([]);
  const [pvcCenters, setPvcCenters] = useState([]);
  const { execute } = useService()
  const { user: { centerId }, pvcAddresses } = useContext(AuthContext)



  const getDestination = async () => {
    try {
      setLoading(true);
      const params = { sessionid: sessionId };
      const response = await axios.post(
        "/api/commerce/inventoryManagement/fetchBusinessUnits",
        params
      );
      setLoading(false);
      setDestinationOptions(response?.data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    //   errorToast("Unable to get destinations!");
    }
  };

  const checkDateDifference = (fromDate: Date, toDate: Date) => {
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    const differenceInTime = toDateObj.getTime() - fromDateObj.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    if (differenceInDays > 30) return true;
    else return false;
  };

  const getSalesData = async () => {
    try {
      let dateRange = checkDateDifference(fromDate, toDate);
      if (dateRange)
        return alert("Date range should be less than 30 days!");

      let centerIds = centerId;

      setLoading(true);
      const params = {
        centerIds,
        fromDate,
        toDate,
      };

    //   const response = await axios.post(
    //     "/api/pvcReports/getSalesReport",
    //     params
    //   );
      const { data } = await execute(() => getSalesReport({params}))

      setLoading(false);
      setSalesReportData(data?.data || []);
    } catch (error) {
      setLoading(false);
      console.error(error);
      alert("Unable to get Sales report data!");
    }
  };

  const getSalesDataColumns = () => {
    let minWidth = 100;

    return salesReportHeader.map((inboundField: any) => {
      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: "left",
      };

      switch (inboundField.id) {
        case "srNo":
          row.minWidth = 80;
          row.valueGetter = (params) => {
            return params.row.srNo;
          };
          break;
        case "gtNumber":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.gtNumber;
          };
          break;
        case "orderID":
          row.minWidth = 100;
          row.valueGetter = (params) => {
            return params.row.orderID ? params.row.orderID : "NA";
          };
          break;
        case "fromCustomer":
          row.minWidth = 300;
          row.valueGetter = (params) => {
            return params.row.fromCustomer;
          };
          break;
        case "DeliveryLocation":
          row.minWidth = 300;
          row.valueGetter = (params) => {
            return params.row.DeliveryLocation;
          };
          break;
        case "BillingLocation":
          row.minWidth = 300;
          row.valueGetter = (params) => {
            return params.row.BillingLocation;
          };
          break;
        case "deliveryType":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.deliveryType;
          };
          break;
        case "InvoiceType":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.InvoiceType;
          };
          break;
        case "InvoiceCategory":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.InvoiceCategory;
          };
          break;
        case "referenceName":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.referenceName;
          };
          break;
        case "referenceNumber":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.referenceNumber;
          };
          break;
        case "totalNetWeightGm":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.totalNetWeightGm;
          };
          break;
        case "totalFineWeight":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.totalFineWeight;
          };
          break;
        case "grossRate":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.grossRate;
          };
          break;
        case "tcsPercentage":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.tcsPercentage;
          };
          break;
        case "tcsAmount":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.tcsAmount;
          };
          break;
        case "totalCGSTValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.totalCGSTValue;
          };
          break;
        case "totalSGSTValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.totalSGSTValue;
          };
          break;
        case "totalIGSTValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.totalIGSTValue;
          };
          break;
        case "cardCharges":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.cardCharges;
          };
          break;
        case "discount":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.discount;
          };
          break;
        case "totalDiscountValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.totalDiscountValue;
          };
          break;
        case "KFCPercentage":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.KFCPercentage;
          };
          break;
        case "KFCAmount":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.KFCAmount;
          };
          break;
        case "adjustment":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.adjustment;
          };
          break;
        case "grandTotal":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.grandTotal;
          };
          break;
        case "sku":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.sku;
          };
          break;
        case "productName":
          row.minWidth = 300;
          row.valueGetter = (params) => {
            return params.row.productName;
          };
          break;
        case "netWeight":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.netWeight;
          };
          break;
        case "fineWeight":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.fineWeight;
          };
          break;
        case "discountValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.discountValue;
          };
          break;
        case "CGSTPercentage":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.CGSTPercentage;
          };
          break;
        case "CGSTValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.CGSTValue;
          };
          break;
        case "SGSTPercentage":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.SGSTPercentage;
          };
          break;
        case "SGSTValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.SGSTValue;
          };
          break;
        case "IGSTPercentage":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.IGSTPercentage;
          };
          break;
        case "IGSTValue":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.IGSTValue;
          };
          break;
        case "valueOfMetal":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.valueOfMetal;
          };
          break;
        case "createdOn":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.createdOn;
          };
          break;
        case "remarks":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.remarks;
          };
          break;
        case "status":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.status;
          };
          break;
        case "cancelledOn":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.cancelledOn;
          };
          break;
        case "cancelReason":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.cancelReason;
          };
          break;

        case "sourceDeliveryLocation":
          row.minWidth = 300;
          row.valueGetter = (params) => {
            return params.row.sourceDeliveryLocation
              ? params.row.sourceDeliveryLocation
              : "NA";
          };
          break;
        case "deliveryDate":
          row.minWidth = 150;
          row.valueGetter = (params) => {
            return params.row.deliveryDate ? params.row.deliveryDate : "NA";
          };
          break;
        case "metal":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.metal ? params.row.metal : "NA";
          };
          break;
        case "weight":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.weight ? params.row.weight : 0;
          };
          break;
        case "purity":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.purity ? params.row.purity : 0;
          };
          break;
        case "doQuantity":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.doQuantity ? params.row.doQuantity : 0;
          };
          break;
        case "customer":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.customer ? params.row.customer : "NA";
          };
          break;
        case "category":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.category ? params.row.category : "NA";
          };
          break;
          case "monthName":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.monthName ? params.row.monthName : "NA";
          };
          break;
        // case "nameLocation":
        //   row.minWidth = 150;
        //   row.valueGetter = (params) => {
        //     return params.row.nameLocation ? params.row.nameLocation : "NA";
        //   };
        //   break;
        // case "invoiceQuantity":
        //   row.minWidth = 120;
        //   row.valueGetter = (params) => {
        //     return params.row.invoiceQuantity ? params.row.invoiceQuantity : 0;
        //   };
        //   break;
        // case "invoiceWeight":
        //   row.minWidth = 120;
        //   row.valueGetter = (params) => {
        //     return params.row.invoiceWeight ? params.row.invoiceWeight : 0;
        //   };
        //   break;
        case "perPcRate":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.perPcRate ? params.row.perPcRate : 0;
          };
          break;
        case "invoiceNo":
          row.minWidth = 150;
          row.valueGetter = (params) => {
            return params.row.invoiceNo ? params.row.invoiceNo : "NA";
          };
          break;
        case "invoiceDate":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.invoiceDate ? params.row.invoiceDate : "NA";
          };
          break;
        case "createdBy":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.createdBy ? params.row.createdBy : "NA";
          };
          break;
          case "productHsnCode":
            row.minWidth = 120;
            row.valueGetter = (params) => {
              return params.row.productHsnCode ? params.row.productHsnCode : "NA";
            };
            break;
         case "customerPan":
            row.minWidth = 120;
            row.valueGetter = (params) => {
              return params.row.customerPan ? params.row.customerPan : "NA";
            };
            break;
         case "customerTan":
            row.minWidth = 120;
            row.valueGetter = (params) => {
              return params.row.customerTan ? params.row.customerTan : "NA";
            };
            break;
         case "customerMobile":
            row.minWidth = 120;
            row.valueGetter = (params) => {
              return params.row.customerMobile ? params.row.customerMobile : "NA";
            };
            break;
         case "customerGstin":
            row.minWidth = 160;
            row.valueGetter = (params) => {
              return params.row.customerGstin ? params.row.customerGstin : "NA";
            };
            break;
          case "shippingCityName":
            row.minWidth = 130;
            row.valueGetter = (params) => {
              return params.row.shippingCityName ? params.row.shippingCityName : "NA";
            };
            break;
          case "shippingState":
            row.minWidth = 130;
            row.valueGetter = (params) => {
              return params.row.shippingState ? params.row.shippingState : "NA";
            };
            break;
          case "shippingStateCode":
            row.minWidth = 120;
            row.valueGetter = (params) => {
                return params.row.shippingStateCode ? params.row.shippingStateCode : "NA";
            };
            break;
          case "billingCityName":
            row.minWidth = 130;
            row.valueGetter = (params) => {
                return params.row.billingCityName ? params.row.billingCityName : "NA";
            };
            break;
          case "billingState":
            row.minWidth = 120;
            row.valueGetter = (params) => {
                return params.row.billingState ? params.row.billingState : "NA";
            };
            break;
          case "billingStateCode":
            row.minWidth = 120;
            row.valueGetter = (params) => {
                return params.row.billingStateCode ? params.row.billingStateCode : "NA";
            };
            break;
          case "billingGstin":
            row.minWidth = 160;
            row.valueGetter = (params) => {
                return params.row.billingGstin ? params.row.billingGstin : "NA";
            };
            break;
          case "suppliersCity":
            row.minWidth = 120;
            row.valueGetter = (params) => {
                return params.row.suppliersCity ? params.row.suppliersCity : "NA";
            };
            break;
          case "suppliersState":
            row.minWidth = 120;
            row.valueGetter = (params) => {
                return params.row.suppliersState ? params.row.suppliersState : "NA";
            };
            break;
          case "suppliersStateCode":
            row.minWidth = 120;
            row.valueGetter = (params) => {
                return params.row.suppliersStateCode ? params.row.suppliersStateCode : "NA";
            };
            break;
          case "suppliersGstin":
            row.minWidth = 160;
            row.valueGetter = (params) => {
                return params.row.suppliersGstin ? params.row.suppliersGstin : "NA";
            };
            break;
          default:
            row.minWidth = 100;
            break;
      }
      return row;
    });
  };

  const filterModal = () => {
    return (
      <Box className={styles.filterModal}>
        <Box className={styles.boxModalOne}>
        </Box>
        <Box className={styles.filterModalRow}>
          <Box className={styles.boxModalTwo}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: "small" },
                  field: {
                    InputProps: {
                      endAdornment: (
                        <IconButton>
                          <CalendarIcon />
                        </IconButton>
                      ),
                    },
                  },
                }}
                label="Start Date"
                onChange={(value) => setFromDate(value?.toString()!)}
                value={moment(
                  fromDate || (new Date().toString() as MomentInput)
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: "small" },
                  field: {
                    InputProps: {
                      endAdornment: (
                        <IconButton>
                          <CalendarIcon />
                        </IconButton>
                      ),
                    },
                  },
                }}
                label="End Date"
                onChange={(value) => setToDate(value?.toString()!)}
                value={moment(toDate || (new Date().toString() as MomentInput))}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            <Button
              variant="contained"
              onClick={getSalesData}
              endIcon={<SearchIcon />}
              disabled={!fromDate || !toDate}
            >
              Apply Filter
            </Button>
          </Box>
        </Box>
        {/* <Typography variant="caption" display="block" marginTop="5px">
          {'Note: Date filter will be applicable on Stock transfer created date.'}
        </Typography> */}
      </Box>
    );
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={{ fileName: "Sales Report" }} />
      </GridToolbarContainer>
    );
  };

  const renderTable = () => {
    return (
      <>
        <div>
          {loading && <CircularModal thickness={4} />}
          <Box sx={{ width: "100%", height: "500px", overflow: "auto" }}>
            <DataGridContainer>
              <ReportsTable
                className="payrollGrid"
                rows={salesReportData || []}
                columns={getSalesDataColumns()}
                getRowId={(row) => row.srNo}
                disableRowSelectionOnClick={true}
                rowHeight={50}
                slots={{ toolbar: CustomToolbar }}
                hideFooter={true}
                fixedHeight={true}
              />
            </DataGridContainer>
          </Box>
        </div>
      </>
    );
  };

  useEffect(() => {
    getDestination();
  }, []);

  return (
    <Box className={styles.container}>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Sales Report</Title>
      {filterModal()}
      {renderTable()}
    </Box>
  );
};

export default SalesReport;
